import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Help } from './pages/Help';
import { Contact } from './pages/Contact';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <Routes data-id="element-3">
        <Route path="/" element={<App data-id="element-5" />} data-id="element-4" />
        <Route path="/help" element={<Help data-id="element-7" />} data-id="element-6" />
        <Route path="/contact" element={<Contact data-id="element-9" />} data-id="element-8" />
        <Route path="*" element={<App data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}